<template lang="pug">
.liquidation-batch-list
  .filters-bar
    el-input(
      v-model="search"
      placeholder="Buscar por lote, prestador..."
      size="small"
      clearable
      style="width:240px"
      @clear="loadBatches"
      @keyup.enter.native="loadBatches"
    )
    el-select(v-model="filterYear" size="small" @change="loadBatches")
      el-option(v-for="y in yearOptions" :key="y" :label="y" :value="y")
    el-select(v-model="filterMonth" size="small" clearable placeholder="Todos los meses" @change="loadBatches")
      el-option(v-for="m in monthOptions" :key="m.value" :label="m.label" :value="m.value")
    el-select(v-model="filterStatus" size="small" clearable placeholder="Todos los estados" @change="loadBatches")
      el-option(label="Pendiente" value="pending")
      el-option(label="Liquidado" value="liquidated")
      el-option(label="Inconsistencia" value="inconsistency")
      el-option(label="Rechazado" value="rejected")
    el-button(type="primary" size="small" @click="openWizard") + Nuevo lote

  spinner(v-if="isLoading")

  .empty-state(v-else-if="!batches.length")
    p Sin lotes en el período seleccionado

  el-table(v-else :data="batches" style="width:100%" @row-click="openDetail")
    el-table-column(label="Lote" width="160")
      template(slot-scope="s")
        span.lote-code LOTE-{{ s.row.createdAt | year }}-{{ String(s.row._id).slice(-6).toUpperCase() }}
    el-table-column(label="Prestador")
      template(slot-scope="s")
        span {{ providerName(s.row.providerSnapshot) }}
    el-table-column(label="Período" width="100")
      template(slot-scope="s")
        span {{ s.row.billingPeriod.month }}/{{ s.row.billingPeriod.year }}
    el-table-column(label="TRX" width="60" align="center")
      template(slot-scope="s")
        strong {{ s.row.items.length }}
    el-table-column(label="Esperado" width="110" align="right")
      template(slot-scope="s")
        span {{ s.row.expectedTotal | fmtMoney }}
    el-table-column(label="Facturado" width="110" align="right")
      template(slot-scope="s")
        span(:class="s.row.amountsMatch === false ? 'amount-bad' : 'amount-ok'") {{ s.row.invoicedTotal | fmtMoney }}
    el-table-column(label="Origen" width="100")
      template(slot-scope="s")
        el-tag(size="mini" :type="s.row.origin === 'automatic' ? 'primary' : 'info'")
          | {{ s.row.origin === 'automatic' ? 'Automático' : 'Manual' }}
    el-table-column(label="Estado" width="130")
      template(slot-scope="s")
        el-tag(size="small" :type="statusType(s.row.status)") {{ statusLabel(s.row.status) }}

  //- WIZARD nuevo lote
  el-dialog(
    title="Nuevo lote de liquidación"
    :visible.sync="wizardVisible"
    width="560px"
    :close-on-click-modal="false"
  )
    .wizard-steps
      .wizard-step-item(v-for="(s,i) in ['Seleccionar TRX','Datos factura','Confirmar']" :key="i")
        .step-circle(:class="stepClass(i+1)") {{ wizardStep > i+1 ? '✓' : i+1 }}
        .step-label {{ s }}
        .step-line(v-if="i < 2")

    //- Paso 1
    div(v-if="wizardStep === 1")
      .field-row
        .field
          label Prestador
          el-select(v-model="wProvider" size="small" filterable placeholder="Seleccionar" @change="loadPendingItems" style="width:100%")
            el-option(v-for="p in providers" :key="p._id" :label="p.displayName" :value="p._id")
        .field
          label Período
          el-select(v-model="wYear" size="small" @change="loadProviders" style="width:100%")
            el-option(v-for="y in yearOptions" :key="y" :label="y" :value="y")
          el-select(v-model="wMonth" size="small" @change="loadProviders" style="width:100%;margin-top:6px")
            el-option(v-for="m in monthOptions" :key="m.value" :label="m.label" :value="m.value")
      spinner(v-if="loadingItems")
      .empty-state(v-else-if="!pendingItems.length") Sin transacciones pendientes para este prestador y período
      .items-list(v-else)
        .item-row(v-for="item in pendingItems" :key="item._id" @click="toggleItem(item._id)")
          el-checkbox(:value="selectedItems.includes(item._id)" @change="toggleItem(item._id)")
          span.trx-code {{ item.transactionCode || '—' }}
          span.trx-name {{ item.practiceSnapshot && item.practiceSnapshot.name || '—' }}
          span.trx-amount {{ item.expectedAmount | fmtMoney }}
      .total-bar(v-if="selectedItems.length")
        span {{ selectedItems.length }} seleccionadas
        strong Total esperado: {{ selectedTotal | fmtMoney }}

    //- Paso 2
    div(v-if="wizardStep === 2")
      .field-row
        .field
          label N° Factura
          el-input(v-model="wInvoice.invoiceNumber" size="small" placeholder="0001-00001234")
        .field
          label Fecha
          el-date-picker(v-model="wInvoice.invoiceDate" size="small" type="date" style="width:100%")
      .field-row
        .field
          label CUIT
          el-input(v-model="wInvoice.cuit" size="small" placeholder="20-12345678-9")
        .field
          label Razón social
          el-input(v-model="wInvoice.razonSocial" size="small")
      .field-row
        .field
          label Neto sin IVA
          el-input(v-model.number="wInvoice.netAmount" size="small" placeholder="0")
        .field
          label Total con IVA
          el-input(v-model.number="wInvoice.totalAmount" size="small" placeholder="0")
      .field
        label Adjunto PDF (opcional)
        input(type="file" accept=".pdf,.jpg,.jpeg,.png" @change="onFileChange" style="margin-top:6px")
      .field
        label Notas
        el-input(v-model="wNotes" size="small" type="textarea" :rows="2")

    //- Paso 3
    div(v-if="wizardStep === 3")
      .summary-card
        .summary-row
          span.summary-label Prestador
          span {{ providerName(selectedProviderObj) }}
        .summary-row
          span.summary-label Período
          span {{ wMonth }}/{{ wYear }}
        .summary-row
          span.summary-label TRX incluidas
          strong {{ selectedItems.length }}
        .summary-row
          span.summary-label Factura N°
          span {{ wInvoice.invoiceNumber }}
        .summary-divider
        .summary-row
          span.summary-label Total esperado
          strong {{ selectedTotal | fmtMoney }}
        .summary-row
          span.summary-label Total facturado
          strong {{ wInvoice.totalAmount | fmtMoney }}
      .match-alert(:class="amountsWillMatch ? 'match-ok' : 'match-bad'")
        | {{ amountsWillMatch ? 'Los montos coinciden dentro de la tolerancia' : 'Los montos no coinciden — quedará en bandeja de inconsistencias' }}

    template(slot="footer")
      el-button(size="small" @click="wizardVisible = false") Cancelar
      el-button(v-if="wizardStep > 1" size="small" @click="wizardStep--") ← Volver
      el-button(
        v-if="wizardStep < 3"
        type="primary"
        size="small"
        :disabled="!canGoNext"
        @click="wizardStep++"
      ) Siguiente →
      el-button(
        v-if="wizardStep === 3"
        type="primary"
        size="small"
        :loading="isSaving"
        @click="confirmBatch"
      ) Confirmar lote
</template>

<script>
import Spinner from "@/components/ui/Spinner";
import liquidationBatchService from "@/services/liquidation-batch";
import liquidationService from "@/services/liquidation";

/**
 * @component LiquidationBatchList
 * @description Listado y creación de lotes de liquidación con wizard de 3 pasos
 */
export default {
  name: "LiquidationBatchList",
  components: { Spinner },
  filters: {
    fmtMoney(v) {
      if (v === null || v === undefined) return "—";
      return (
        "$ " +
        Number(v)
          .toFixed(0)
          .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
      );
    },
    year(v) {
      return v ? new Date(v).getFullYear() : "—";
    },
  },
  data() {
    return {
      isLoading: false,
      batches: [],
      search: "",
      filterYear: new Date().getFullYear(),
      filterMonth: new Date().getMonth() + 1,
      filterStatus: null,
      wizardVisible: false,
      wizardStep: 1,
      wProvider: null,
      wYear: new Date().getFullYear(),
      wMonth: new Date().getMonth() + 1,
      wInvoice: {
        invoiceNumber: "",
        razonSocial: "",
        cuit: "",
        netAmount: null,
        totalAmount: null,
        invoiceDate: null,
      },
      wNotes: "",
      wFile: null,
      pendingItems: [],
      selectedItems: [],
      loadingItems: false,
      isSaving: false,
      providers: [],
      tolerance: null,
    };
  },
  computed: {
    yearOptions() {
      const y = new Date().getFullYear();
      return [y - 2, y - 1, y];
    },
    monthOptions() {
      return [
        { value: 1, label: "Enero" },
        { value: 2, label: "Febrero" },
        { value: 3, label: "Marzo" },
        { value: 4, label: "Abril" },
        { value: 5, label: "Mayo" },
        { value: 6, label: "Junio" },
        { value: 7, label: "Julio" },
        { value: 8, label: "Agosto" },
        { value: 9, label: "Septiembre" },
        { value: 10, label: "Octubre" },
        { value: 11, label: "Noviembre" },
        { value: 12, label: "Diciembre" },
      ];
    },
    selectedTotal() {
      return this.pendingItems
        .filter((i) => this.selectedItems.includes(i._id))
        .reduce((acc, i) => acc + (i.expectedAmount || 0), 0);
    },
    selectedProviderObj() {
      return this.providers.find((p) => p._id === this.wProvider) || {};
    },
    canGoNext() {
      if (this.wizardStep === 1) return this.selectedItems.length > 0;
      if (this.wizardStep === 2)
        return !!this.wInvoice.invoiceNumber && !!this.wInvoice.totalAmount;
      return true;
    },
    amountsWillMatch() {
      if (!this.wInvoice.totalAmount || !this.selectedTotal) return false;
      const diff = Math.abs(this.wInvoice.totalAmount - this.selectedTotal);
      if (!this.tolerance?.toleranceValue) return diff === 0;
      if (this.tolerance.toleranceType === "absolute")
        return diff <= this.tolerance.toleranceValue;
      const pct =
        this.selectedTotal > 0 ? (diff / this.selectedTotal) * 100 : 0;
      return pct <= this.tolerance.toleranceValue;
    },
  },
  created() {
    this.loadBatches();
    this.loadProviders();
    this.loadTolerance();
  },
  methods: {
    /**
     * @method loadBatches
     * @description Carga el listado de lotes con filtros activos
     */
    async loadBatches() {
      this.isLoading = true;
      try {
        const params = { billingYear: this.filterYear };
        if (this.filterMonth) params.billingMonth = this.filterMonth;
        if (this.filterStatus) params.status = this.filterStatus;
        const data = await liquidationBatchService.getAll(params);
        this.batches = data.docs || data;
      } finally {
        this.isLoading = false;
      }
    },
    /**
     * @method loadProviders
     * @description Carga prestadores de la red para el wizard
     */
    async loadProviders() {
      try {
        const data = await liquidationService.get({
          status: "pending",
          billingYear: this.wYear,
          billingMonth: this.wMonth,
          limit: 200,
        });
        const items = data.docs || data;
        const seen = new Set();
        this.providers = items
          .filter((i) => i.providerSnapshot?._id)
          .filter((i) => {
            const id = i.providerSnapshot._id.toString();
            if (seen.has(id)) return false;
            seen.add(id);
            return true;
          })
          .map((i) => ({
            _id: i.providerSnapshot._id,
            firstName: i.providerSnapshot.firstName || "",
            lastName: i.providerSnapshot.lastName || "",
            displayName:
              i.providerSnapshot.firstName || i.providerSnapshot.lastName
                ? `${i.providerSnapshot.lastName}, ${i.providerSnapshot.firstName}`
                : `Prestador ${String(i.providerSnapshot._id).slice(-6)}`,
          }));
      } catch (e) {
        this.providers = [];
      }
    },
    /**
     * @method loadTolerance
     * @description Carga configuración de tolerancia
     */
    async loadTolerance() {
      try {
        const data = await liquidationService.getToleranceConfig();
        this.tolerance = data;
      } catch (e) {
        /* silent */
      }
    },
    /**
     * @method loadPendingItems
     * @description Carga LiquidationItems pendientes del prestador y período seleccionado
     */
    async loadPendingItems() {
      if (!this.wProvider || !this.wYear || !this.wMonth) return;
      this.loadingItems = true;
      this.selectedItems = [];
      try {
        const data = await liquidationService.get({
          providerId: this.wProvider,
          billingYear: this.wYear,
          billingMonth: this.wMonth,
          status: "pending",
        });
        this.pendingItems = data.docs || data;
      } finally {
        this.loadingItems = false;
      }
    },
    toggleItem(id) {
      const idx = this.selectedItems.indexOf(id);
      if (idx === -1) this.selectedItems.push(id);
      else this.selectedItems.splice(idx, 1);
    },
    openWizard() {
      this.wizardStep = 1;
      this.wProvider = null;
      this.wInvoice = {
        invoiceNumber: "",
        razonSocial: "",
        cuit: "",
        netAmount: null,
        totalAmount: null,
        invoiceDate: null,
      };
      this.wNotes = "";
      this.wFile = null;
      this.pendingItems = [];
      this.selectedItems = [];
      this.wizardVisible = true;
    },
    openDetail(row) {
      this.$emit("open-detail", row._id);
    },
    onFileChange(e) {
      this.wFile = e.target.files[0] || null;
    },
    /**
     * @method confirmBatch
     * @description Crea el lote y sube el archivo si hay uno adjunto
     */
    async confirmBatch() {
      this.isSaving = true;
      try {
        const batch = await liquidationBatchService.create({
          itemIds: this.selectedItems,
          invoiceData: this.wInvoice,
          notes: this.wNotes,
          origin: "manual",
        });
        if (this.wFile) {
          await liquidationBatchService.uploadInvoiceFile(
            batch._id,
            this.wFile
          );
        }
        this.$message.success("Lote creado correctamente");
        this.wizardVisible = false;
        this.loadBatches();
      } catch (e) {
        this.$message.error(e.response?.data?.message || "Error al crear lote");
      } finally {
        this.isSaving = false;
      }
    },
    providerName(s) {
      if (!s) return "—";
      if (s.businessName) return s.businessName;
      if (s.lastName) return `${s.lastName}, ${s.firstName || ""}`;
      return "—";
    },
    statusLabel(s) {
      return (
        {
          pending: "Pendiente",
          liquidated: "Liquidado",
          inconsistency: "Inconsistencia",
          rejected: "Rechazado",
        }[s] || s
      );
    },
    statusType(s) {
      return (
        {
          pending: "info",
          liquidated: "success",
          inconsistency: "danger",
          rejected: "danger",
        }[s] || ""
      );
    },
    stepClass(n) {
      if (n < this.wizardStep) return "done";
      if (n === this.wizardStep) return "active";
      return "pending";
    },
  },
};
</script>

<style lang="scss" scoped>
.liquidation-batch-list {
  padding: 8px 0;
}
.filters-bar {
  display: flex;
  gap: 8px;
  margin-bottom: 16px;
  align-items: center;
  flex-wrap: wrap;
}
.empty-state {
  padding: 32px;
  text-align: center;
  color: #6b7294;
  font-size: 14px;
}
.lote-code {
  font-weight: 700;
  color: #002d5e;
  font-size: 13px;
}
.amount-ok {
  color: #1d9e75;
  font-weight: 600;
}
.amount-bad {
  color: #e24b4a;
  font-weight: 600;
}
.wizard-steps {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
}
.wizard-step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 4px;
  flex: 1;
  position: relative;
}
.step-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 700;
  &.done {
    background: #1d9e75;
    color: white;
  }
  &.active {
    background: #002d5e;
    color: white;
  }
  &.pending {
    background: #f0f2f7;
    color: #6b7294;
  }
}
.step-label {
  font-size: 10px;
  color: #6b7294;
  text-align: center;
}
.step-line {
  position: absolute;
  top: 14px;
  left: 60%;
  width: 80%;
  height: 1px;
  background: #e2e8f0;
  z-index: 0;
}
.field-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 12px;
}
.field {
  display: flex;
  flex-direction: column;
  gap: 4px;
  margin-bottom: 10px;
  label {
    font-size: 11px;
    font-weight: 600;
    color: #6b7294;
    text-transform: uppercase;
    letter-spacing: 0.4px;
  }
}
.items-list {
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
  max-height: 240px;
  overflow-y: auto;
  margin-bottom: 10px;
}
.item-row {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 8px 12px;
  border-bottom: 1px solid #f0f2f7;
  font-size: 12px;
  cursor: pointer;
  &:last-child {
    border-bottom: none;
  }
  &:hover {
    background: #f8f9fc;
  }
}
.trx-code {
  font-family: monospace;
  color: #05c49a;
  font-weight: 700;
  min-width: 90px;
}
.trx-name {
  flex: 1;
  color: #1a1f36;
}
.trx-amount {
  font-weight: 600;
  color: #1a1f36;
  white-space: nowrap;
}
.total-bar {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  padding: 8px 0;
  border-top: 1px solid #e2e8f0;
  margin-top: 4px;
}
.summary-card {
  background: #f8f9fc;
  border-radius: 8px;
  border: 1px solid #e2e8f0;
  padding: 14px;
  margin-bottom: 14px;
}
.summary-row {
  display: flex;
  justify-content: space-between;
  font-size: 13px;
  padding: 4px 0;
}
.summary-label {
  color: #6b7294;
}
.summary-divider {
  height: 1px;
  background: #e2e8f0;
  margin: 8px 0;
}
.match-alert {
  border-radius: 8px;
  padding: 10px 14px;
  font-size: 13px;
  margin-bottom: 4px;
  &.match-ok {
    background: #eaf3de;
    border: 1px solid #c5e0a8;
    color: #3b6d11;
  }
  &.match-bad {
    background: #fcebeb;
    border: 1px solid #f5c1c1;
    color: #a32d2d;
  }
}
</style>
